import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions = [];

class Packages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
    };
  }
  componentDidMount() {
    services
      .getPackages()
      .then((response) => {
        const tmp = response.data.data.filter((item) => item.is_valid);
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: tmp[i].plan,
          });
        }
        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange = (selectedOption) => {
    this.props.handlePackageChange(selectedOption);
  };

  render() {
    const { options } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="Package"
        placeholder="Select Packages"
        value={options.filter(({ value }) => value === this.props.value)}
        isDisabled={this.props.disabled || false}
        menuPortalTarget={document.body}
      />
    );
  }
}

export { Packages };
